import init_favorite_items_list from "./favorite-items"
import init_favorite_users from "./favorite-users"

export default function init() {
    init_favorite_items_list()
    init_favorite_users()
}
